<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h5 class="title">{{ title }}</h5>
        <button
          v-if="createAllowed"
          id="btn-add"
          type="button"
          class="btn btn-icon btn-round btn-success"
          aria-label="Ajouter élément à la liste"
          @click="create"
        >
          <i class="fa fa-plus" />
        </button>
      </div>
      <div class="card-body table-responsive table-full-width">
        <el-table :data="records" class="mydatalist" @row-click="rowClicked">
          <slot />
        </el-table>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6 pagination-info">
        <p class="category">Total: {{ pagination.total }} éléments</p>
      </div>
      <div class="col-sm-6">
        <p-pagination
          v-model="pagination.currentPage"
          :per-page="pagination.perPage"
          :total="pagination.total"
          class="pull-right"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import PPagination from 'src/components/UIComponents/Pagination.vue';
import { Table, TableColumn } from 'element-ui';
import EventBus from 'src/event-bus';

Vue.use(Table);
Vue.use(TableColumn);

export default {
  components: {
    PPagination,
  },
  props: ['title', 'fetchData', 'createAllowed'],
  data() {
    return {
      searchText: '',
      loading: false,
      records: [],
      pagination: {
        perPage: 12,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
    };
  },
  watch: {
    'pagination.currentPage': {
      handler(newValue, oldValue) {
        this.fetch(this.pagination.currentPage);
      },
    },
  },
  created() {
    // Remove event listener potentially set by Overview component
    EventBus.$off('search');
    this.fetch(1);
  },
  mounted() {
    EventBus.$on('search', this.search);
  },
  beforeDestroy() {
    EventBus.$off('search', this.search);
  },
  methods: {
    rowClicked(event) {
      this.$emit('row-clicked', event);
    },
    fetch(current) {
      this.pagination.currentPage = current;
      this.loading = true;
      this.fetchData(
        this.pagination.currentPage,
        this.pagination.perPage,
        this.searchText,
      ).then(response => {
        /*
        if (response.records.length < this.pagination.perPage) {
          const missing = this.pagination.perPage - response.records.length;
          for (let i = 0; i < missing; i++) {
            response.records.push({});
          }
        }
        */
        this.loading = false;
        this.records = response.records;
        this.pagination.total = response.page.totalElements;
      });
    },
    search(searchText) {
      this.searchText = searchText;
      this.fetch(1);
    },
    create() {
      this.$emit('create');
    },
  },
};
</script>

<style scoped>
.mydatalist >>> tr {
  cursor: pointer;
}

.spinner {
  position: absolute;
  top: -2px;
  right: -4px;
}

#btn-add {
  position: absolute;
  right: 10px;
  top: 10px;
  margin: 0px;
}
</style>
